import {
  Container,
  Header,
  KeyValuePairs,
  KeyValuePairsProps,
  Link,
} from "@amzn/awsui-components-console";
import { FixedFeeConfig } from "@amzn/fuse-accounting-central-datastore-client";
import React from "react";
import { RegionalDomain } from "src/config/BartLambdaConfig";
import { getTransactionInfo } from "src/pages/commons/transaction-info";

interface Props {
  fixedFeeConfig: FixedFeeConfig;
  domain: RegionalDomain;
}

export const AdditionalInfoContainer: React.FC<Props> = ({
  fixedFeeConfig,
  domain,
}) => {
  const items: KeyValuePairsProps.Item[] = [];

  // Matcher
  const accounts: Record<string, string> = {
    "23200": "Unearned Revenue",
  };

  if (fixedFeeConfig.reclassBalance) {
    accounts["18203"] = "Long-term Receivables";
    accounts["28655"] = "Long-term Deferred Revenue";
  }

  const transactionInfo = getTransactionInfo(
    `${fixedFeeConfig.fixedFeeId}.Payment`,
    "CHARGE",
    fixedFeeConfig.environment === "TEST",
    domain,
    {
      matcher: {
        matchKey: fixedFeeConfig.fixedFeeId!,
        accounts: new Set(Object.keys(accounts)),
      },
    },
  );

  if (transactionInfo.matcher) {
    items.push({
      type: "group",
      title: "Matcher",
      items: Object.entries(transactionInfo.matcher).map(
        ([account, matcherLink]) => ({
          label: `${accounts[account]}`,
          value: (
            <Link external href={matcherLink}>
              {account}
            </Link>
          ),
        }),
      ),
    });
  }

  return items.length > 0 ? (
    <Container header={<Header>Additional Info</Header>}>
      <KeyValuePairs columns={4} items={items} />
    </Container>
  ) : (
    <></>
  );
};
